(function () {
  'use strict';

  var GALLERY_PRELOAD_DELAY_MS = 750;

  function loadDeferredImage(img) {
    if (!img || img.dataset.mpLoaded === 'true') return;

    var srcset = img.getAttribute('data-mp-defer-srcset');
    var src = img.getAttribute('data-mp-defer-src');

    if (srcset) {
      img.srcset = srcset;
      img.removeAttribute('data-mp-defer-srcset');
    }

    if (src) {
      img.src = src;
      img.removeAttribute('data-mp-defer-src');
    }

    if (!src && !srcset) return;

    img.dataset.mpLoaded = 'true';
    img.classList.remove('mp-deferred-media');
  }

  function loadDeferredVideo(video) {
    if (!video || video.dataset.mpLoaded === 'true') return;

    var src = video.getAttribute('data-mp-defer-src');
    if (!src) return;

    video.src = src;
    video.removeAttribute('data-mp-defer-src');
    video.dataset.mpLoaded = 'true';

    if (video.hasAttribute('data-mp-autoplay')) {
      video.play().catch(function () {});
    }
  }

  function preloadGalleryImages(root) {
    root.querySelectorAll('img[data-mp-defer-src]:not([data-mp-defer-on-open])').forEach(loadDeferredImage);
  }

  function scheduleGalleryPreload(root) {
    window.setTimeout(function () {
      preloadGalleryImages(root);
    }, GALLERY_PRELOAD_DELAY_MS);
  }

  function initGalleryDeferredImages(root) {
    root.querySelectorAll('img[data-mp-defer-src]:not([data-mp-defer-on-open])').forEach(function (img) {
      var slide = img.closest('.slider__slide');
      if (slide && slide.classList.contains('is-active')) {
        loadDeferredImage(img);
      }
    });

    scheduleGalleryPreload(root);

    root.querySelectorAll('.slider__slide').forEach(function (slide) {
      if (slide.dataset.mpDeferSlideBound === 'true') return;
      slide.dataset.mpDeferSlideBound = 'true';

      var slideObserver = new MutationObserver(function () {
        if (!slide.classList.contains('is-active')) return;
        slide.querySelectorAll('img[data-mp-defer-src]').forEach(loadDeferredImage);
      });

      slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function initViewportDeferredVideos(root) {
    root.querySelectorAll('video[data-mp-defer-src]:not([data-mp-defer-on-open])').forEach(function (video) {
      if (!('IntersectionObserver' in window)) {
        loadDeferredVideo(video);
        return;
      }

      var videoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadDeferredVideo(entry.target);
            videoObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '400px 0px', threshold: 0.01 }
      );

      videoObserver.observe(video);
    });
  }

  function init(root) {
    root = root || document;
    initGalleryDeferredImages(root);
    initViewportDeferredVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.MPDeferredAssets = {
    loadImage: loadDeferredImage,
    loadVideo: loadDeferredVideo,
  };
})();
